module.exports = __webpack_public_path__ + "img/icon-info.f9d71edc.svg";